import request from '@/utils/request'

export const ping = () =>
  request({
    url: '/ping',
    method: 'get'
  })
